import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandedAll = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.7319 18.5867C10.2856 19.033 9.56082 19.033 9.11454 18.5867L2.2597 11.7319C1.81342 11.2856 1.81342 10.5608 2.2597 10.1145C2.70598 9.66827 3.43073 9.66827 3.87701 10.1145L9.92499 16.1625L15.973 10.1181C16.4192 9.67183 17.144 9.67183 17.5903 10.1181C18.0366 10.5644 18.0366 11.2892 17.5903 11.7354L10.7354 18.5903L10.7319 18.5867ZM17.5867 4.87701L10.7319 11.7319C10.2856 12.1781 9.56082 12.1781 9.11454 11.7319L2.2597 4.87701C1.81342 4.43073 1.81342 3.70598 2.2597 3.2597C2.70598 2.81342 3.43073 2.81342 3.87701 3.2597L9.92499 9.30767L15.973 3.26327C16.4192 2.81699 17.144 2.81699 17.5903 3.26327C18.0366 3.70955 18.0366 4.4343 17.5903 4.88058L17.5867 4.87701Z",
		fill: "#0D2976"
	})
});
export default SvgExpandedAll;
